import React from 'react'
import { Button } from '@instacart/tds'
import { useActionFlow } from '~shared/lib/ActionFlow'
import styles from '../ManageMenuModal.module.scss'

export const ManageMenuCloseFooter: React.FC<{ disabled: boolean }> = ({ disabled }) => {
  const { close } = useActionFlow()

  return (
    <div className={styles.buttonGroup}>
      <Button.Group>
        <Button disabled={disabled} onClick={close}>
          Close
        </Button>
      </Button.Group>
    </div>
  )
}
